export const SCREEN_MAX_SIZES = {
  phone: 380,
  smart: 480,
  phablet: 600,
  tablet: 960,
  desktop: 1140,
  big: 1280,
  hd: 1440
}
